export class GoogleMapService {
    constructor($timeout) {
        'ngInject';
        this.$timeout = $timeout;
        this.map = '';
        this.directionsService = new google.maps.DirectionsService;
        this.directionsDisplay = new google.maps.DirectionsRenderer({
            suppressMarkers: true,
            preserveViewport: true
        });
    }

    setMapInstance(map) {
        this.map = map;
    }

    getRoute(config, delay = 0, showStatus = false) {
        return new Promise((resolve, reject) => {
          this.directionsService.route(config, (resp, status) => {
                if (showStatus) {
                    console.log(status);
                }
                resolve(resp);
            });  
        });
        // return new Promise((resolve, reject) => {
        //     if (delay > 0) {
        //         this.$timeout(() => {
        //             this.directionsService.route(config, (resp, status) => {
        //                 if (showStatus) {
        //                     console.log(status);
        //                 }
        //                 resolve(resp);
        //             });
        //         }, delay);
        //     } else {
        //         this.directionsService.route(config, (resp, status) => {
        //             resolve(resp);
        //         });
        //     }
        // });
    }

    getNearbyPlace(map, location, radius) {
        const searchRequest = {
            location,
            radius,
            type: ['bus_station']
        };

        let service = new google.maps.places.PlacesService(map);
        return new Promise((resolve, reject) => {
            service.nearbySearch(searchRequest, (resp, status) => {
                if (status === 'OK') {
                    resolve(resp);
                } else {
                    reject(false);
                }
            });
        });
    }

    drawRoute(origin, destination) {
        // end-marker.png
        let icons = {
            start: new google.maps.MarkerImage('/./images/origin_icon.png'),
            end: new google.maps.MarkerImage('/./images/origin_icon.png')
        };

        const routeConfig = {
            origin,
            destination,
            travelMode: google.maps.TravelMode['DRIVING']
        };
        console.log(map);
        console.log(origin);
        console.log(destination);
        this.directionsService.route(routeConfig, (resp, status) => {
            console.log('->>', resp, this.map);
            const {routes: [{overview_path: overviewPath}]} = resp;
            const polylinePath = this._getPolylineLatLngObject(overviewPath);
            console.log(polylinePath);
            this.drawPolyline(this.map, polylinePath);
            // this.directionsDisplay.setDirections(resp);
            // this.addMarker(map, origin.latlng, icons.start, origin.details);
            // this.addMarker(map, destination.latlng, icons.end, destination.details);
            // waypoints.map(point => {
            //     this.addMarker(map, point.latlng, icons.start, point.details);
            // });
            // (this.latlngDetails.type === 'privateTrip') ? this._getPrivateTravelDirectionDetails(head(resp.routes)) : true;
        });
    }

    _getPolylineLatLngObject(path) {
        return path.map(val => {
            return {
                lat: val.lat(),
                lng: val.lng()
            };
        });
    }

    drawPolyline(map, path) {
        const Polyline = new google.maps.Polyline({
            path,
            geodesic: true,
            strokeColor: '#e06e27',
            strokeOpacity: 1.0,
            strokeWeight: 3
        });

        Polyline.setMap(map);
    }
}


// WEBPACK FOOTER //
// ./src/app/common/components/google-map/google-map.service.js